package ir.hosen.resume.styles

import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.background
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.percent

val ToggleTheme = CssStyle {
    base {
        Modifier.background(Colors.Transparent)
    }

    hover {
        Modifier.background(Colors.Gray.copy(alpha = 50)).borderRadius(50.percent)
    }
}